import { render, staticRenderFns } from "./object-row.vue?vue&type=template&id=4e0d1eb8&scoped=true&"
import script from "./object-row.vue?vue&type=script&lang=js&"
export * from "./object-row.vue?vue&type=script&lang=js&"
import style0 from "./object-row.vue?vue&type=style&index=0&id=4e0d1eb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d1eb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VExpandTransition,VIcon,VRow,VSheet})
